import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './components/Home';
import Blog from './components/Blog';
import ContactPage from './components/contact';
import About from './components/About';
import Media from './components/pages/Media';
import BlogList from './components/pages/blog/BlogList';
import BlogArticle from './components/pages/blog/BlogArticle';
import Admin from './components/admin/Admin';

import Trust from './components/pages/Trust';
import Playground from './components/pages/Playground';
import Models from './components/pages/Models';
import Changelog from './components/pages/Changelog';
import Platform from './components/pages/Platform';
import Sectors from './components/pages/Sectors';
import Architecture from './components/pages/Architecture';
import RouteErrorBoundary from './components/RouteErrorBoundary';

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [location.pathname, location.hash]);
  return null;
}

export default function App() {
  const location = useLocation();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <ScrollToTop />

      <main style={{ flex: 1 }}>
        <RouteErrorBoundary locationKey={location.pathname}>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/blogs" element={<Blog />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/media" element={<Media />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<Admin />} />

          {/* 2026 AI-company surfaces */}
          <Route path="/platform" element={<Platform />} />
          <Route path="/architecture" element={<Architecture />} />
          <Route path="/sectors" element={<Sectors />} />
          <Route path="/trust" element={<Trust />} />
          <Route path="/playground" element={<Playground />} />
          <Route path="/models" element={<Models />} />
          <Route path="/changelog" element={<Changelog />} />

          {/* Back-compat routes (from older links) */}
          <Route path="/services/*" element={<Navigate to="/platform" replace />} />
          <Route path="/Services/*" element={<Navigate to="/platform" replace />} />
          <Route path="/Blogs" element={<Navigate to="/blogs" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </RouteErrorBoundary>
      </main>

      <Footer />
    </div>
  );
}
